import React from 'react';
import * as S from './WorkspaceButton.styles';
import { Icon, Text } from '@nicheinc/campus-ds';

type WorkspaceButtonPropsType = {
	focused?: boolean;
	workspaceName: string;
	canSwitchWorkspace: boolean;
};
function WorkspaceButton(
	{
		focused,
		workspaceName,
		canSwitchWorkspace,
		...rest
	}: WorkspaceButtonPropsType,
	ref: React.Ref<HTMLDivElement>,
) {
	return (
		<S.ButtonContainer
			focused={focused}
			disabled={!canSwitchWorkspace}
			role="button"
			tabIndex={0}
			ref={ref}
			{...rest}
		>
			<S.ButtonWrapper>
				<S.ButtonDetails>
					<Text size="small" color="system.text.default">
						Workspace
					</Text>

					<Text
						size="xs"
						lineHeight="medium"
						color="system.text.medium"
						lineClamp={1}
						noWrap
					>
						{workspaceName || 'Loading...'}
					</Text>
				</S.ButtonDetails>
				{canSwitchWorkspace && (
					<Icon
						iconName="chevronRight"
						weight="regular"
						color="system.border.medium"
						size="xs"
					/>
				)}
			</S.ButtonWrapper>
		</S.ButtonContainer>
	);
}

export default React.forwardRef(WorkspaceButton);
